import React from 'react';
import { Button, Typography } from 'tfc-components';

import Icon, { IconName } from 'components/atoms/Icon';
import mapModifiers from 'utils/functions';

interface ButtonData {
  label: string;
  action: () => void;
  order?: number;
}

interface BannerProps {
  backgroundImage: string;
  icon?: IconName;
  title: string;
  content: React.ReactNode | string;
  buttonPrimary?: ButtonData;
  buttonSecondary?: ButtonData;
  textColor?: 'black' | 'white';
}

const Banner: React.FC<BannerProps> = ({
  backgroundImage,
  icon,
  title,
  content,
  buttonPrimary,
  buttonSecondary,
  textColor,
}) => (
  <div className="o-banner">
    <div
      className={`o-banner_container${(icon || '') && '-sizing'}`}
      style={{ backgroundImage: `url(${backgroundImage})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
    >
      <div className={`o-banner_content${(icon || '') && '-sizing'}`}>
        {icon && (
          <div className="o-banner_icTitleContain">
            <Icon className="o-banner_icTitle" iconName={icon} size="64" />
          </div>
        )}
        <Typography.Heading type="h2" fontweight="600" extendClasses={mapModifiers('fs-36x48 o-banner_title', icon && 'spacing', textColor && `${textColor}`)}>{title}</Typography.Heading>
        <p style={{ color: textColor }} className="o-banner_contentText f-20x24">{content}</p>
        <div className="o-banner_buttons">
          {buttonSecondary && (
            <Button extendClasses="o-banner_button o-banner_button-first fButton f-16x24" onClick={buttonSecondary.action}>
              {buttonSecondary.label}
            </Button>
          )}
          {buttonPrimary && (
            <Button variant="primary" extendClasses="o-banner_button o-banner_button-second fButton f-16x24" onClick={buttonPrimary.action}>
              {buttonPrimary.label}
            </Button>
          )}
        </div>
      </div>
    </div>
  </div>
);

export default Banner;
